export default "__VITE_ASSET__pUeQVP$A__"